module.exports = __webpack_public_path__ + "static/img/green-power-slug_256.f2b6fa5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/green-power-slug_256.png
// module id = 0HjJ
// module chunks = 0